<div class="user-access-management">
  <div class="user-list-panel">
    <mat-card>
      <mat-card-content>
        <h2>Users</h2>
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Search users</mat-label>
          <mat-icon matPrefix>search</mat-icon>
          <input matInput [ngModel]="searchText()" (ngModelChange)="searchText.set($event)" placeholder="Name, username, email, org..."/>
        </mat-form-field>

        <div class="user-table">
          @for (user of filteredUsers(); track user.id) {
            <div
              class="user-row"
              [class.selected]="selectedUser()?.id === user.id"
              (click)="selectUser(user)"
            >
              <div class="user-name">{{ user.firstName }} {{ user.lastName }}</div>
              <div class="user-email">{{ user.email }}</div>
            </div>
          } @empty {
            <p class="empty-message">No users found.</p>
          }
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="access-panel">
    @if (!selectedUser()) {
      <div class="no-selection">
        <mat-icon>person_search</mat-icon>
        <p>Select a user to manage their access</p>
      </div>
    } @else {
      <mat-card>
        <mat-card-content>
          <h2>Access for {{ selectedUser()!.firstName }} {{ selectedUser()!.lastName }}</h2>

          @if (loadingAccess()) {
            <div class="loading">
              <mat-spinner diameter="40"></mat-spinner>
              <p>Loading access...</p>
            </div>
          } @else {
            <mat-accordion multi>

              <!-- Map Layers Section -->
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <mat-icon>layers</mat-icon>
                    Map Layers
                  </mat-panel-title>
                  <mat-panel-description>
                    {{ selectedLayerIds().size }} layer(s) selected
                  </mat-panel-description>
                </mat-expansion-panel-header>

                @for (group of layerGroups(); track group.id) {
                  <div class="layer-group">
                    <div class="group-header">
                      <mat-checkbox
                        [checked]="isAllLayersInGroupSelected(group.id)"
                        [indeterminate]="isSomeLayersInGroupSelected(group.id)"
                        (change)="toggleAllLayersInGroup(group.id, $event.checked)"
                      >
                        <strong>{{ group.displayName }}</strong>
                      </mat-checkbox>
                    </div>
                    @for (layer of group.layers; track layer.id) {
                      <div class="layer-item">
                        <mat-checkbox
                          [checked]="isLayerSelected(layer.id)"
                          (change)="toggleLayer(layer.id, $event.checked)"
                        >
                          {{ layer.displayName }}
                        </mat-checkbox>
                      </div>
                    }
                  </div>
                  <mat-divider></mat-divider>
                }

                <div class="action-row">
                  <button mat-flat-button color="primary" (click)="saveLayerAccess()">
                    Save Map Layer Access
                  </button>
                </div>
              </mat-expansion-panel>

              <!-- Reports Section -->
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <mat-icon>description</mat-icon>
                    Reports
                  </mat-panel-title>
                  <mat-panel-description>
                    {{ selectedReportIds().size }} report(s) selected
                  </mat-panel-description>
                </mat-expansion-panel-header>

                @for (group of reportGroups(); track group.id) {
                  <div class="layer-group">
                    <div class="group-header">
                      <mat-checkbox
                        [checked]="isAllReportsInGroupSelected(group.id)"
                        [indeterminate]="isSomeReportsInGroupSelected(group.id)"
                        (change)="toggleAllReportsInGroup(group.id, $event.checked)"
                      >
                        <strong>{{ group.displayName }}</strong>
                      </mat-checkbox>
                    </div>
                    @for (report of group.reports; track report.id) {
                      <div class="layer-item">
                        <mat-checkbox
                          [checked]="isReportSelected(report.id)"
                          (change)="toggleReport(report.id, $event.checked)"
                        >
                          {{ report.displayName }}
                        </mat-checkbox>
                      </div>
                    }
                  </div>
                  <mat-divider></mat-divider>
                }

                <div class="action-row">
                  <button mat-flat-button color="primary" (click)="saveReportAccess()">
                    Save Report Access
                  </button>
                </div>
              </mat-expansion-panel>

            </mat-accordion>
          }
        </mat-card-content>
      </mat-card>
    }
  </div>
</div>
